var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pa-0 fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "fill-height elevation-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.attributes, function (row) {
    return _c('v-list-item', {
      key: row.label || row.id,
      staticClass: "view-row",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', [row.type === 'anchor' ? [_vm._t(row.id)] : [_c('v-list-item-title', {
      staticClass: "title-text"
    }, [!['date', 'datetime', 'array', 'file'].includes(row.type) ? _c('span', [row.reference ? _c('span', {
      staticClass: "redirect",
      on: {
        "click": function ($event) {
          return _vm.onClickReference(row, row.value);
        }
      }
    }, [_vm._v(" " + _vm._s(row.value.name) + " ")]) : _c('span', [_vm._v(" " + _vm._s(row.value) + " ")])]) : row.type === 'array' ? _c('span', [_c('v-chip-group', {
      staticClass: "mt-2",
      attrs: {
        "column": "",
        "active-class": "primary--text",
        "tag": "",
        "multiple": ""
      }
    }, _vm._l(row.value, function (item) {
      return _c('v-chip', {
        key: item.id,
        staticClass: "ma-1 chip-text",
        attrs: {
          "small": "",
          "outlined": ""
        },
        on: {
          "click": function ($event) {
            row.reference && _vm.onClickReference(row, item);
          }
        }
      }, [_vm._v(" " + _vm._s(item.name) + " ")]);
    }), 1)], 1) : ['date', 'datetime'].includes(row.type) ? _c('span', [_vm._v(" " + _vm._s(_vm.displayDate(row.value, row.type)) + " ")]) : row.type === 'file' ? _c('span', [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "dark": ""
      },
      on: {
        "click": row.onClick
      }
    }, [_vm._v(" " + _vm._s(row.display || 'View File') + " ")])], 1) : _vm._e()]), _c('v-list-item-subtitle', {
      staticClass: "subtitle-text"
    }, [_vm._v(" " + _vm._s(row.label) + " ")])]], 2)], 1);
  }), 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }